import React, { useState, useEffect } from 'react';
import BestList from '../../components/List/bestList';
import Loading from '../../components/Common-components/loading';
import { apiGet } from '../../utils/api';

export default function BestListPage() {
    // mainList.js와 동일하게 초기값을 빈 배열로 설정하고, 로딩 상태를 별도로 관리합니다.
    const [listData, setListData] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        const fetchBestList = async () => {
            setIsLoading(true);
            try {
                // mainList.js와 동일한 API 주소 사용
                const res = await apiGet('/main/get_main_cruise_list.php');
                // mainList.js와 동일한 데이터 처리 방식
                if (res.result === 'success') {
                    setListData(res.data.best);
                } else {
                    setListData([]);
                }
            } catch (error) {
                console.error("베스트 크루즈 목록을 불러오는데 실패했습니다:", error);
                setListData([]);
            }
            setIsLoading(false);
        };

        fetchBestList();
    }, []);

    if (isLoading) {
        return <Loading isLoading={true} />;
    }

    return <BestList listData={listData} pageTitle="베스트셀러 크루즈" />;
}
